














































































































import Vue, { PropType } from 'vue';
import BaseButton from '~/components/builders/Base/Button.vue';
import Select, { SelectOption } from '~/components/builders/Base/Select.vue';
import YearMonthPicker from '~/components/builders/YearMonthPicker.vue';
import { CandidateSchool, StudyField, StudyLevel, StudyProgram } from '~/services/CSPService';
import { CandidateJobBuilder, JobCSP } from '~/utils/candidate';

export interface CSPForm {
    school: string;
    program: string;
    campus: string;
    level: string;
    field: string;
    start: Date;
    end: Date;

    customSchool: boolean;
    customProgram: boolean;
    newProgram: boolean;
}

export default Vue.extend({
    name: 'StudyProgramForm',
    components: {
        Select,
        YearMonthPicker,
        BaseButton,
    },
    props: {
        csp: {
            type: Object as PropType<JobCSP>,
            required: true,
        },
        schools: {
            type: Array as PropType<CandidateSchool[]>,
            required: true,
        },
        levels: {
            type: Array as PropType<StudyLevel[]>,
            required: true,
        },
        fields: {
            type: Array as PropType<StudyField[]>,
            required: true,
        },
        schoolStudyPrograms: {
            type: Map as PropType<Map<string, StudyProgram[]>>,
            required: true,
        },
    },
    data() {
        return {
            form: null as CSPForm | null,
        };
    },
    computed: {
        disabled(): Record<string, boolean> {
            if (!this.form) return {};

            const schoolId = Number(this.form.school);
            const schoolSelected =
                (this.form.customSchool && !!this.form.school) ||
                this.schools.some(s => !!this.form && s.id === schoolId);

            return {
                program: !schoolSelected,
                campus: !schoolSelected || this.optionsCampuses.length < 2,
                level: !schoolSelected || !this.form.customProgram,
                field: !schoolSelected || !this.form.customProgram,
                dates: !schoolSelected,
            };
        },
        valid(): boolean {
            if (!this.form) return false;

            const schoolValid = this.form.customSchool
                ? !!this.form.school
                : !!this.form.school &&
                  this.schools.some(s => !!this.form && s.id === Number(this.form.school));

            const levelValid = !this.form.customProgram || !!this.form.level;
            const fieldValid = !this.form.customProgram || !!this.form.field;
            const timeValid = this.form.start <= this.form.end;

            return schoolValid && !!this.form.program && levelValid && fieldValid && timeValid;
        },

        optionsSchools(): SelectOption[] {
            if (!this.form) return [];

            const options = this.schools.map(school => ({
                value: String(school.id),
                label: school.name,
            }));

            if (this.form.customSchool)
                options.unshift({
                    value: this.form.school,
                    label: this.form.school,
                });

            return options;
        },
        optionsStudyPrograms(): SelectOption[] {
            if (!this.form) return [];

            if (this.form.customSchool)
                return this.form.customProgram && !!this.form.program
                    ? [{ value: this.form.program, label: this.form.program }]
                    : [];

            const options: SelectOption[] = (
                this.schoolStudyPrograms.get(this.form.school) || []
            ).map(program => ({
                value: program.id,
                label: program.level ? `${program.name} (${program.level.name})` : program.name,
            }));

            if (this.form.customProgram && !!this.form.program)
                options.unshift({
                    value: this.form.program,
                    label: this.form.program,
                    isCustom: true,
                });
            else if (
                !!this.csp.studyProgram &&
                !this.csp.studyProgram.isVerified &&
                !!this.csp.studyProgram.name
            )
                options.unshift({
                    value: this.csp.studyProgram.name,
                    label: this.csp.studyProgram.name,
                    isCustom: true,
                });

            return options;
        },
        optionsCampuses(): SelectOption[] {
            if (!this.form) return [];
            if (this.form.customSchool || this.form.customProgram || !this.form.program) return [];

            const ssps = this.schoolStudyPrograms.get(this.form.school);
            if (!ssps) return [];

            const program = ssps.find(s => !!this.form && s.id === this.form.program);
            if (!program || !program.campuses) return [];

            return program.campuses.map(c => ({
                value: c.id,
                label: c.name,
            }));
        },
        optionsLevels(): SelectOption[] {
            return this.levels.map(level => ({
                value: level.id,
                label: level.name,
            }));
        },
        optionsFields(): SelectOption[] {
            return this.fields.map(field => ({
                value: field.id,
                label: field.name,
            }));
        },

        isTempItem(): boolean {
            return CandidateJobBuilder.isTempItem(this.csp);
        },
    },
    methods: {
        initForm() {
            if (!this.csp.studyProgram) return;

            const field = this.csp.studyProgram.fields ? this.csp.studyProgram.fields[0] : null;
            const campus = !!this.csp.campusId
                ? this.csp.campusId
                : !!this.optionsCampuses.length
                ? this.optionsCampuses[0].value
                : '';
            this.form = {
                school:
                    this.csp.studyProgram.customSchoolName ||
                    String(this.csp.studyProgram.schoolId || -1),
                program: this.csp.studyProgram.isVerified
                    ? this.csp.programId || ''
                    : this.csp.studyProgram.name,
                campus,
                level: this.csp.studyProgram.levelId,
                field: field ? field.id : '',
                start: this.csp.start,
                end: this.csp.end,

                customSchool: !!this.csp.studyProgram.customSchoolName,
                customProgram: !this.csp.studyProgram.isVerified,
                newProgram: false,
            };
        },

        handleSchoolChange(value: string, custom: boolean) {
            if (!this.form) return;
            this.form.school = value;
            this.form.customSchool = custom;

            if (custom) {
                this.form.customProgram = true;
                this.form.program = '';
            }
        },
        handleProgramChange(value: string, custom: boolean, options: SelectOption[]) {
            if (!this.form) return;
            this.form.program = value;
            this.form.customProgram = custom;
            this.form.newProgram = custom && options.every(o => o.value !== value);

            if (!custom && !this.form.customSchool && this.form.school) {
                this.$nextTick(() => {
                    if (!!this.form) {
                        if (value === this.csp.programId && !!this.csp.campusId) {
                            this.form.campus = this.csp.campusId;
                            return;
                        }

                        const ssps = this.schoolStudyPrograms.get(this.form.school);
                        if (!ssps) return;

                        const program = ssps.find(s => !!this.form && s.id === this.form.program);
                        if (!program) return;

                        this.form.level = program.level ? program.level.id : '';
                        this.form.field =
                            program.fields && program.fields.length ? program.fields[0].id : '';
                        this.form.campus =
                            program.campuses && program.campuses.length
                                ? program.campuses[0].id
                                : '';
                    }
                });
            }
        },
    },
    watch: {
        form: {
            deep: true,
            handler(value: CSPForm) {
                this.$emit('input', value);
            },
        },
        valid: {
            deep: true,
            handler(value: boolean) {
                this.$emit('validated', value);
            },
        },
    },
    mounted() {
        this.initForm();
    },
});
